/**
 * @copyright @2022 Techechelons Infosolutions Pvt. Ltd. All rights reserved.
 * @description Tabs component to override default Mui Tabs's style.
 * --------------------------------------------------------------------
 * Creation Details
 * @author Naishad Vaishnav
 * Date Created: 14/Nov/2022
 * FDO Ref:
 * TDO Ref:
 * RTM Ref:
 * Test Case Ref:
 */

// ----------------------------------------------------------------------

/**
 * Tabs contains the styles to override default Mui Tabs and it's children's styles.
 *
 * @component
 * @param theme - global theme object to provide colors, fonts, spacing, shadows etc.
 * @returns Add-on styles for MuiTabs
 */
export default function Tabs(theme) {
  /* Output */
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          ...theme.typography.h5,
          overflow: 'visible',
          padding: 0,
          minWidth: 0,
          color: theme.palette.common.white,
          position: 'relative',
          '&.Mui-selected': {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightBold
          },
          '&:not(:last-child)': {
            marginRight: theme.spacing(7.5)
          },
          '@media (min-width: 600px)': {
            minWidth: 0
          }
        },
        labelIcon: {
          paddingTop: 0,
          '& > .MuiTab-wrapper > *:first-of-type': {
            marginBottom: 0,
            marginRight: theme.spacing(1)
          }
        },
        wrapper: {
          flexDirection: 'row',
          whiteSpace: 'nowrap'
        },
        textColorInherit: {
          opacity: 1,
          color: theme.palette.text.secondary
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          background: 'url(/assets/images/lines/blue_149.svg) no-repeat center',
          backgroundSize: '100%',
          height: 12,
          bottom: -1
        }
      }
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0
        }
      }
    }
  };
}
